import {ReportModel} from "@fedeltapointofsale/data-client";
import {StockMovementAuditReportData} from "./stock-movement-audit-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class StockMovementAuditReportModel extends ReportModel<StockMovementAuditReportData> {
    constructor(injector: Injector) {
        super(injector, StockMovementAuditReportData);
    }
}
